module.exports = __webpack_public_path__ + "static/media/Japan.210b218c.png";